<template>
  <b-form id="source_submit" @submit="onSubmit">
    <div class="row">
      <div class="col-sm-12">
        <b-form-group label="Группа">
          <v-select :options="groups" v-model="form.group">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>
        <b-form-group label="Валюта">
          <v-select :options="currency" required v-model="form.currency">
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>
        <b-form-group label="Ответственный МБ">
          <v-select label="name" :options="activeUsers"
                    required v-model="form.selectedResponsibleBuyer" placeholder="Ответственный МБ" >
            <span slot="no-options">Совпадений не найдено.</span>
          </v-select>
        </b-form-group>
        <b-button
            type="submit"
            class="float-right"
            variant="primary">Сохранить и выйти
        </b-button>
      </div>
    </div>

    <div class="form-errors"></div>
  </b-form>
</template>
<script>
import OffersService from '../../../services/offersDataService'
import SourcesService from '../../../services/sourcesDataService'
import sourcesService from "../../../services/sourcesDataService";
import UsersService from '../../../services/usersDataService'

export default {
  name: 'MassEditSourcesModal',
  components: {
    OffersService: OffersService
  },
  props: {
    sources: {},
  },
  data() {
    return {
      form: {
        group: null,
        currency: null,
        selectedResponsibleBuyer: null
      },
      groups: [],
      currency: [],
      submitted: false
    }
  },
  methods: {
    onSubmit(evt, close) {
      let sourcesArray = []

      Object.keys(this.sources).forEach(function(key){
        if (this.sources[key]) {
          sourcesArray.push(key)
        }
      }.bind(this))

      if (this.form.selectedResponsibleBuyer) {
        this.form.responsible_buyer_id = this.form.selectedResponsibleBuyer.id
      }

      this.form.sourcesIds = sourcesArray
      return sourcesService.updateSources(this.form)
    },
    getGroups() {
      SourcesService.getGroups()
          .then(function (groups) {
            this.groups = groups;
          }.bind(this))
    },
    getCurrency() {
      OffersService.getCurrency()
          .then(function (response) {

            this.currency = response;
          }.bind(this))
    },
    getActiveUsers() {
      UsersService.getActiveUsers()
        .then(function (users) {
          this.activeUsers = users;
        }.bind(this))
    },
  },
  beforeMount() {
    this.getCurrency();
    this.getGroups();
    this.getActiveUsers();
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/views/front/modals/MassUpdateSourcesModal.vue